(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-box-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pm-box-purchase')) {
    customElements.define('pm-box-purchase', class extends HTMLElement {
      connectedCallback() {
        this.builder = this.closest('pm-box-builder');
        if (!this.builder) return;
        if (!this.config) {
          try { this.config = JSON.parse(this.querySelector('[data-purchase-config]').textContent); } catch { return; }
          this.form = this.querySelector('[data-purchase-form]');
          this.button = this.querySelector('[data-purchase-submit]');
          this.status = this.querySelector('[data-purchase-status]');
          this.onMixChange = () => this.render();
          this.onSubmit = event => this.submit(event);
        }
        this.builder.addEventListener('pm:mix-change', this.onMixChange);
        this.form.addEventListener('submit', this.onSubmit);
        this.render();
      }
      readMix() {
        const capacity = Number(this.builder.dataset.capacity);
        const flavors = this.config.flavors.map(product => {
          const card = this.builder.querySelector(`[data-mix-flavor="${product.index}"]`);
          const count = Number(card?.querySelector('[data-quantity]')?.textContent);
          return { ...product, count, name: card?.dataset.name || product.title || '' };
        });
        const valid = [6, 12].includes(capacity) && flavors.length > 0 && flavors.every(flavor => Number.isInteger(flavor.count) && flavor.count >= 0);
        const full = valid && flavors.reduce((total, flavor) => total + flavor.count, 0) === capacity;
        return { capacity, flavors, full, summary: flavors.filter(flavor => flavor.count).map(flavor => `${flavor.count} × ${flavor.name}`).join(' · ') };
      }
      resolveProduct(mix) {
        if (!mix.full) return null;
        const fixedHandles = ['chocolate-chip', 'oatmeal-chocolate-chip', 'matcha-white-chip'];
        const custom = this.config.custom[String(mix.capacity)];
        if (this.config.customEnabled && custom?.id && ![...fixedHandles, 'sample-pack'].includes(custom.handle)) return { ...custom, custom: true };
        const fullFlavor = mix.flavors.find(flavor => flavor.count === 12 && flavor.id && flavor.singleVariant && fixedHandles.includes(flavor.handle));
        if (mix.capacity === 12 && fullFlavor) return { ...fullFlavor, custom: false };
        const sample = this.config.sample;
        if (mix.capacity === 12 && sample.id && sample.handle === 'sample-pack' && sample.singleVariant && mix.flavors.length === 3 && fixedHandles.every(handle => mix.flavors.filter(flavor => flavor.handle === handle && flavor.count === 4).length === 1)) return { ...sample, custom: false };
        return null;
      }
      render() {
        const mix = this.readMix();
        const product = this.resolveProduct(mix);
        const strings = this.config.strings;
        this.currentMix = mix;
        this.currentProduct = product;
        this.hidden = !mix.full && !this.pending && !this.uncertain && !this.added;
        if (this.hidden) { this.status.textContent = ''; this.lastSignature = ''; return; }
        const displayMix = this.pending || this.uncertain || this.added ? this.submittedMix : mix;
        const displayProduct = this.pending || this.uncertain || this.added ? this.submittedProduct : product;
        const previewPrice = !displayProduct && this.config.previewPrices?.[String(displayMix.capacity)];
        this.querySelector('[data-purchase-mix]').textContent = displayMix.summary;
        const title = this.querySelector('[data-purchase-product]');
        title.hidden = false;
        title.textContent = strings.boxLabel.replace('[count]', String(displayMix.capacity));
        this.querySelector('[data-purchase-price-row]').hidden = !displayProduct && !previewPrice;
        this.querySelector('[data-purchase-price-label]').textContent = displayProduct ? strings.total : strings.previewPrice;
        this.querySelector('[data-purchase-price]').textContent = displayProduct?.price || previewPrice || '';
        this.form.hidden = !displayProduct;
        const variant = this.querySelector('[data-purchase-variant]');
        variant.value = displayProduct?.id || '';
        variant.disabled = !displayProduct;
        const mixProperty = this.querySelector('[data-purchase-mix-property]');
        const sizeProperty = this.querySelector('[data-purchase-size-property]');
        const boxProperty = this.querySelector('[data-purchase-box-property]');
        mixProperty.value = displayMix.summary;
        sizeProperty.value = String(displayMix.capacity);
        boxProperty.disabled = mixProperty.disabled = sizeProperty.disabled = !displayProduct;
        this.button.disabled = !displayProduct?.available || !!this.pending || !!this.uncertain || !!this.added;
        this.button.setAttribute('aria-busy', String(!!this.pending));
        this.querySelector('[data-purchase-label]').textContent = this.pending ? strings.adding : this.uncertain ? strings.checkCart : this.added ? strings.added : !displayProduct?.available ? strings.soldOut : strings.add;
        this.querySelector('[data-purchase-coming]').hidden = !!displayProduct;
        this.querySelector('[data-purchase-cart]').hidden = !this.uncertain && !this.added;
        this.querySelector('[data-purchase-browse]').hidden = !!this.pending;
        const signature = JSON.stringify([mix.capacity, mix.flavors.map(flavor => flavor.count)]);
        if (!this.pending && !this.uncertain && !this.added && signature !== this.lastSignature) this.status.textContent = product && !product.available ? strings.unavailable : '';
        this.lastSignature = signature;
      }
      async submit(event) {
        event.preventDefault();
        if (this.pending || this.uncertain || this.added) return;
        const mix = this.readMix();
        const product = this.resolveProduct(mix);
        if (!product?.available) { this.render(); return; }
        const strings = this.config.strings;
        const item = {
          id: product.id,
          quantity: 1,
          properties: { [strings.boxProperty]: strings.boxName, [strings.sizeProperty]: String(mix.capacity), [strings.mixProperty]: mix.summary }
        };
        this.submittedMix = mix;
        this.submittedProduct = product;
        this.pending = true;
        this.status.textContent = strings.adding;
        this.render();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [item] }), signal: controller.signal });
          const result = await response.json().catch(() => null);
          if (!response.ok) {
            if (response.status >= 400 && response.status < 500) {
              this.status.textContent = typeof result?.description === 'string' ? result.description : strings.error;
            } else { this.uncertain = true; this.status.textContent = strings.uncertain; }
            return;
          }
          if (!Array.isArray(result?.items) || !result.items.some(addedItem => String(addedItem.variant_id || addedItem.id) === String(product.id) && addedItem.quantity >= 1)) {
            this.uncertain = true;
            this.status.textContent = strings.uncertain;
            return;
          }
          this.added = true;
          this.status.textContent = strings.added;
          if (this.isConnected) window.location.assign(this.config.cartUrl);
        } catch {
          this.uncertain = true;
          this.status.textContent = strings.uncertain;
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.render();
        }
      }
      disconnectedCallback() {
        this.builder?.removeEventListener('pm:mix-change', this.onMixChange);
        this.form?.removeEventListener('submit', this.onSubmit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pm-chippy-chinup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pm-chippy-chinup')) {
    customElements.define('pm-chippy-chinup', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.body = this.querySelector('[data-chinup-body]');
        this.arms = ['left', 'right'].map(side => ({ upper: this.querySelector(`[data-arm-${side}]`), lower: this.querySelector(`[data-forearm-${side}]`) }));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.played = false;
        this.visible = false;
        this.ready = false;
        this.pose(0);
        this.preload = new Image();
        this.preload.addEventListener('load', () => { this.ready = true; this.classList.add('is-ready'); this.start(); }, options);
        this.preload.src = this.querySelector('image').getAttribute('href');
        if (this.preload.complete && this.preload.naturalWidth) { this.ready = true; this.classList.add('is-ready'); }
        this.querySelector('button').addEventListener('click', () => this.play(), options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.play(); }, options);
        this.motion.addEventListener('change', () => this.stop(), options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start(); else this.stop();
        }, { threshold: .5 });
        this.observer.observe(this);
      }
      segment(element, from, to, mirror) {
        const dx = to.x - from.x, dy = to.y - from.y, length = Math.hypot(dx, dy);
        element.setAttribute('transform', `matrix(${mirror * dy / length},${-mirror * dx / length},${dx / 60},${dy / 60},${from.x},${from.y})`);
      }
      pose(lift) {
        const rise = 116 * lift;
        this.body.setAttribute('transform', `translate(0,${-rise})`);
        this.arms.forEach((arm, index) => {
          const sign = index === 0 ? -1 : 1;
          const shoulder = { x: 150 + sign * 38, y: 198 - rise };
          const wrist = { x: 150 + sign * 84, y: 104 };
          const dx = wrist.x - shoulder.x, dy = wrist.y - shoulder.y;
          const distance = Math.hypot(dx, dy), ux = dx / distance, uy = dy / distance;
          const along = (58 * 58 - 67 * 67 + distance * distance) / (2 * distance);
          const bend = Math.sqrt(Math.max(0, 58 * 58 - along * along));
          const elbow = { x: shoulder.x + along * ux - sign * bend * uy, y: shoulder.y + along * uy + sign * bend * ux };
          this.segment(arm.upper, shoulder, elbow, -sign);
          this.segment(arm.lower, wrist, elbow, -sign);
        });
      }
      start() {
        if (this.played || !this.visible || !this.ready) return;
        this.played = true;
        this.play();
      }
      play() {
        if (this.motion.matches || !this.visible || !this.ready || this.running) return;
        this.running = true;
        let start;
        const smooth = value => value * value * (3 - 2 * value);
        const tick = now => {
          start ??= now;
          const progress = Math.min(1, (now - start) / 2400);
          let lift;
          if (progress < .12) lift = 0;
          else if (progress < .47) lift = smooth((progress - .12) / .35);
          else if (progress < .59) lift = 1;
          else lift = 1 - smooth((progress - .59) / .41);
          this.pose(lift);
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else { this.running = false; this.frame = null; }
        };
        this.frame = requestAnimationFrame(tick);
      }
      stop() { cancelAnimationFrame(this.frame); this.frame = null; this.running = false; if (this.body) this.pose(0); }
      disconnectedCallback() { this.stop(); this.observer?.disconnect(); this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pm-gift-callout"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('pm-gift-callout');
    if (!config) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let launcher;
    let callout;
    let listeners;
    let animations = [];

    const stop = () => {
      animations.forEach(animation => animation.cancel());
      animations = [];
    };

    const point = () => {
      stop();
      if (reducedMotion.matches || document.hidden || !callout?.isConnected) return;
      callout.querySelectorAll('.pm-gift-callout__stroke').forEach(path => {
        animations.push(path.animate([{ strokeDashoffset: 100 }, { strokeDashoffset: 0 }], {
          duration: 480, easing: 'cubic-bezier(.25,.1,.25,1)'
        }));
      });
      callout.querySelectorAll('.pm-gift-callout__tip').forEach(path => {
        animations.push(path.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 120, delay: 380, fill: 'backwards', easing: 'ease-out'
        }));
      });
    };

    const decorate = () => {
      if (launcher?.isConnected && callout?.isConnected && launcher.contains(callout)) return;
      stop();
      listeners?.abort();
      launcher = document.querySelector('.kl-teaser-RkkXJM [data-testid="animated-teaser"] [role="button"]');
      if (!launcher) return;
      launcher.setAttribute('aria-label', config.dataset.label);
      launcher.setAttribute('aria-haspopup', 'dialog');
      launcher.classList.add('pm-gift-launcher');
      callout = config.content.firstElementChild.cloneNode(true);
      launcher.append(callout);
      listeners = new AbortController();
      launcher.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') point();
      }, { signal: listeners.signal });
      launcher.addEventListener('focus', () => {
        if (launcher.matches(':focus-visible')) point();
      }, { signal: listeners.signal });
      point();
    };

    reducedMotion.addEventListener('change', stop);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
    decorate();
    new MutationObserver(decorate).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pm-mix-name"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pm-mix-name')) {
    customElements.define('pm-mix-name', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.builder = this.closest('pm-box-builder');
        if (!this.builder) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.input = this.querySelector('input');
        this.clear = this.querySelector('[data-name-clear]');
        this.titles = [...this.builder.querySelectorAll('.pm-box__lid strong, .pm-box__closed-cover strong')].map(element => ({ element, original: element.textContent }));
        this.input.addEventListener('input', () => this.updateName(), options);
        this.addEventListener('click', event => {
          const suggestion = event.target.closest('[data-name-suggestion]');
          if (suggestion && this.contains(suggestion)) {
            this.input.value = suggestion.dataset.nameSuggestion.slice(0, 28);
            this.updateName();
          } else if (event.target.closest('[data-name-clear]')) {
            this.input.value = '';
            this.updateName();
            this.input.focus();
          }
        }, options);
        this.updateName();
      }
      updateName() {
        const nickname = this.input.value.trim().slice(0, 28);
        this.builder.classList.toggle('has-nickname', !!nickname);
        this.builder.classList.toggle('has-long-nickname', nickname.length > 18 || nickname.split(/\s+/).some(word => word.length > 12));
        this.titles.forEach(({ element, original }) => { element.textContent = nickname || original; });
        this.clear.disabled = !this.input.value;
        this.querySelectorAll('[data-name-suggestion]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.nameSuggestion === nickname)));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.titles?.forEach(({ element, original }) => { element.textContent = original; });
        this.builder?.classList.remove('has-nickname', 'has-long-nickname');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
